import request from "@/plugins/request";
import {baseApi} from "@/api/scope";

// 新增用户
export function addMenu(data) {
    return request.post(baseApi, { action: 'addmenu', ...data });
}

export function  getMenuList(data) {
    return request.post(baseApi, { action: 'getmenulist', ...data });
}

export function updateMenu(data) {
    return request.post(baseApi, { action: 'updatemenu', ...data });
}
